import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import { AuthProvider, useAuth } from './context/AuthContext';
import VantaBackground from './components/VantaBackground';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to='/' />;
}

export default function App(){
  return (
    <AuthProvider>
      <VantaBackground>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
            <Route path='/dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </VantaBackground>
    </AuthProvider>
  );
}
